import React from 'react';
import { NavLink } from "react-router-dom";

const Lrn_us_sub = () => {
  return (
 <div className='fixed top-24 right-0 left-0  justify-items-stretch w-full  content-center items-center'>      
      <div className='h-12 flex bg-[#007bff] justify-between gap-4'> 
       <NavLink to="/learning/lrn_us_mat" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white rounded-md ' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white rounded-md ' // Inactive styles
        }
      >Mathematics</NavLink>
               <NavLink to="/learning/lrn_us_ela" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white rounded-md' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white rounded-md ' // Inactive styles
        }
      >English Language Arts</NavLink>
               <NavLink to="/learning/lrn_us_sci" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white rounded-md' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white ' // Inactive styles
        }
      >Sciences</NavLink>
               <NavLink to="/learning/lrn_us_soc" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white  rounded-md' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white rounded-md' // Inactive styles
        }
      >Social studies</NavLink>
               <NavLink to="/learning/lrn_us_spa" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white  rounded-md' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white rounded-md' // Inactive styles
        }
      >Spanish</NavLink>              

             
      </div>
    </div>
  );
}

export default Lrn_us_sub;
